module.exports = __webpack_public_path__ + "img/logo2.e9a10c64.svg";